module.exports = __webpack_public_path__ + "img/img_star.59df4236.png";